import React from "react";

import {
  Button,
  Box,
  Dialog,
  Checkbox,
  FormControlLabel,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { TermsOfUseCmp } from "variables/termsOfUse";
import UtilsFncs from "utils/UtilsFncs";
import storageFnc from "lib/localStorage.js";
import hexToRgb from "assets/theme/hex-to-rgb";

const useStyles = makeStyles({
  formControlRoot: {
    "& > span": {
      fontSize: "1rem",
    },
  },
});

const useStylesScroll = makeStyles((theme) => ({
  scrollbarClass: {
    overflowY: "auto",
    marginRight: 10,
    padding: 0,
    "&::-webkit-scrollbar": {
      width: "0.45rem",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "1.5rem",
      borderRadius: 4,
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.2)`,
      outline: `rgba(${hexToRgb(theme.palette.black.main)}, 0.7)`,
    },
  },
}));

export default function DialogTermsOfUse({ open, handleClose, onAccept }) {
  const classes = useStyles();
  const classScrollbar = useStylesScroll();
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);
  const [confirmando, setConfirmando] = React.useState(false);
  const [userIp, setUserIp] = React.useState(null);

  const handleTermsChange = React.useCallback((event) => {
    setAcceptedTerms(event.target.checked);
  }, []);

  const handleCancel = React.useCallback(() => {
    storageFnc.clear();
    handleClose();
  }, [handleClose]);

  React.useEffect(() => {
    UtilsFncs.GetIp((ip) => {
      if (ip) {
        setUserIp(ip);
      }
    });
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Termos de Uso do App e Portal Karsten
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classScrollbar.scrollbarClass,
        }}
        style={{
          padding: "0 1.5rem",
          marginTop: "0.5rem",
        }}
      >
        <DialogContentText id="scroll-dialog-description" tabIndex={-1} color="textPrimary">
          <TermsOfUseCmp />
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                checked={acceptedTerms}
                onChange={handleTermsChange}
                color="primary"
              />
            }
            label="Li e aceito os termos de uso acima."
            labelPlacement="end"
            classes={{
              root: classes.formControlRoot,
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={handleCancel} disabled={confirmando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={() => onAccept()}
          disabled={confirmando || !acceptedTerms}
        >
          {confirmando ? "Salvando Aceite..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
